export default function getResource(label) {
    const resources = {
        freeShippingMessage: 'Expédition gratuite pour les commandes de plus de 50 $'
    };
    return resources[label];
}
